import { colors } from "../../theme/colors";
import React from 'react';
import { useTranslation } from 'react-i18next';
import gundi_logo from '../../images/gundi_logo.png';
import wildlifePhoto from '../../images/login-wildlife.jpg';

type Props = {
  title: string;
  subtitle: string;
  onLogin: () => void;
  titleId?: string;
};

export function LoginScreen({ title, subtitle, onLogin, titleId }: Props) {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-full">
      <div className="hidden lg:flex w-1/2 flex-shrink-0 relative overflow-hidden" style={{ background: colors["unlisted-login-overlay-strong"] }}>
        <img src={wildlifePhoto} alt="" className="h-full w-full object-cover" style={{ transform: 'scale(1.6) translateY(5%)' }} />
        <div className="absolute inset-0" style={{ background: colors["unlisted-login-overlay-soft"] }} />
        <div className="absolute top-4 left-4 flex items-center gap-3">
          <img src={gundi_logo} alt="" className="brightness-0 invert flex-shrink-0" style={{ width: '38px', height: '32px' }} />
          <span className="text-white font-bold" style={{ width: '63px', fontSize: '1.25rem', lineHeight: 1 }}>Gundi</span>
        </div>
        <div className="absolute bottom-8 left-8">
          <span style={{ color: colors["ui-background-elevated-component"], fontFeatureSettings: "'liga' off", textShadow: `0 4px 4px ${colors["unlisted-scrim-25"]}`, fontFamily: '"Helvetica Neue"', fontSize: '12px', fontStyle: 'normal', fontWeight: 400, lineHeight: 'normal' }}>Photo credit: Jes Lefcourt</span>
        </div>
      </div>
      <div className="flex flex-col justify-center items-center flex-1 px-12 py-6" style={{ background: colors["unlisted-login-panel-grey"] }}>
          <div className="flex flex-col justify-center items-center mb-10">
            <img src={gundi_logo} alt="Gundi" className="h-10 mb-3" />
            <span className="text-[32px] font-bold tracking-tight text-ui-text-primary-text">Gundi</span>
          </div>
          <p id={titleId} className="text-center text-lg font-semibold text-ui-text-primary-text mb-2">{title}</p>
          <p className="text-center text-base text-ui-text-primary-text mb-8">{subtitle}</p>
          <button
            type="button"
            className="font-bold flex items-center justify-center box-border h-12 w-full max-w-[350px] m-0 p-4 rounded-md border border-transparent shadow-sm bg-brand-accent-green text-base text-white hover:bg-ui-cta-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ui-cta-primary transition-colors"
            onClick={onLogin}
          >
            {t("Log In")}
          </button>
          <p className="text-center text-sm font-medium mt-4 text-unlisted-form-help-grey">
            {t("No account?")}{' '}
            <a
              href="https://support.earthranger.com/gundi-getting-help/gundi-contact-us"
              target="_blank"
              rel="noopener noreferrer"
              className="text-ui-cta-primary font-semibold hover:text-ui-cta-primary"
            >
              {t("Contact us")}
            </a>
          </p>
      </div>
    </div>
  );
}
